/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Text, Table, Tbody, Tfoot, Tr, Th, Td, Badge, Tooltip, Checkbox, useToast, Center, Input, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import './style.css';
import c from '../../constant';
import useStore from '../../store';
import ReactPaginate from 'react-paginate';
import LoadingTable from '../../components/Table/Loading';
import useMoment from '../../hooks/useMoment';
import PrintLayout from '../Print/PrintLayout';
import LeaveUse from './LeaveUse';
import MonthlyTimesheet from "./MonthlyTimesheet"

const UPDATE_UID_MUTATION = gql`
mutation updateuid($employeeId: String!, $uid: String!){
  updateEmployeeUid(id:$employeeId, uid:$uid)
}
`

const GET_TIMESHEET_DATA = gql`
query getEmployeeTimeSheet($month: String!, $uid: String!){
  	getEmployeesTimeSheetByUid(uid:$uid,month:$month){
		id
		uid
		queryDate
		date
	}
}
`

function TimeSheet({ employeeId, uid }) {
	const history = useHistory();
	const toast = useToast();
	const { t } = useTranslation();
	const { toDateString } = useMoment();
	const { currentLang } = useStore((state) => state.currentLang);
	const [isShowingMore, setShowingMore] = useState(false);
	const [uidValue, setUIDValue] = useState("");
	const [updateUid, { error:errorUpdate, data:dataUpdate, loading:loadingUpdate }] = useMutation(UPDATE_UID_MUTATION);
	const { currentUser } = useStore((state) => state.currentUser);

	useEffect(()=>{
		setUIDValue(uid)
	},[employeeId,uid])

	useEffect(()=>{
		if(dataUpdate){
			toast({
				title: 'Employee scanner id updated.',
				status: 'success',
				duration: 9000,
				isClosable: true,
			})
		}
	},[dataUpdate])

	useEffect(()=>{
		if(errorUpdate){
			toast({
				title: errorUpdate?.graphQLErrors[0]?.message||'Error update employee scanner id.',
				status: 'error',
				duration: 9000,
				isClosable: true,
			})
		}
	},[errorUpdate])

	return (
		<PrintLayout>
			<Center className="show-only-printing">
				<Text textAlign="center" color="#62B3ED" fontFamily="Moul" fontSize={18}>
					Time Sheet
				</Text>
			</Center>
			<Center className="content-detail-leave">
				<Box w="100%" bg="white" borderRadius={c.borderRadius} border="1px solid #dbdbdb" boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)" pb={0}>
					<Flex
						className="hidden-print"
						h="48px"
						p={4}
						pt={0}
						pb={0}
						mb={4}
						bg="#FAFAFA"
						alignItems="center"
						justifyContent="space-between"
						borderBottom="1px solid #dbdbdb"
					/>
					<Flex>
						<MonthlyTimesheet uid={uid}/>
					</Flex>
					{currentUser?.username==='admin'&&<Flex alignItems="center" m="2">
						<Text>Scanner Id</Text>
						<Input 
							value={uidValue} 
							onChange={e=>{
								setUIDValue(e.currentTarget.value)
							}} 
							m="8" ml="1" mr="1" size="xs" w="100px" />
						{uidValue!=uid&&<Button isLoading={loadingUpdate} size="xs" onClick={()=>updateUid({variables:{employeeId, uid: uidValue}})}>Save</Button>}
					</Flex>}
				</Box>
			</Center>
		</PrintLayout>
	);
}

export default TimeSheet;
